import React from 'react';
import { useSelector } from 'react-redux';
import { Tabs } from '@yme/atoms/tabs';
import { PRODUCT_FACT_SHEET_URL, TECH_SPECIFICATIONS_NAME } from '@yme/common/constants';
import { IndentWrapper } from '@yme/components/Separator/IndentWrapper';
import { useWindowSize } from '@yme/hooks/index';
import { getAttributeWithGroupingProducts } from '@yme/pdp-components/ProductCard';
import { getRootLang, getRTL, getProductBlockStrategy } from '@yme/selectors/index';
import { getIsLoadedProductDetails } from '@yme/selectors/products';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { selectColorTheme, onOpenWindow, setDigitalData, DigitalDataMutation, } from '@yme/utils/common';
import { BLANK } from '@yme/utils/constants';
import { SectionHOC } from './SectionHOC';
import { SpecificationLink } from './SpecificationLink';
import { SpecificationsSkeleton } from './SpecificationsSkeleton';
import { SpecificationsTitle } from './SpecificationsTitle';
import { buildTabsData } from './helpers';
export function Specifications({ labels, isRemoveBottomIndent, isInEditor, }) {
    const specification = useSelector(getAttributeWithGroupingProducts(TECH_SPECIFICATIONS_NAME));
    const productFactSheetUrlValue = useSelector(getAttributeWithGroupingProducts(PRODUCT_FACT_SHEET_URL));
    const rootLang = useSelector(getRootLang);
    const isRightToLeft = useSelector(getRTL);
    const productBlockStrategy = useSelector(getProductBlockStrategy);
    const isLoadedProductDetails = useSelector(getIsLoadedProductDetails);
    const currentColorTheme = productBlockStrategy
        ? selectColorTheme(productBlockStrategy?.value)
        : null;
    const { isMobileView } = useWindowSize();
    const specificationData = specification || [];
    const tabsData = (specificationData.length &&
        buildTabsData({
            data: specificationData,
            lang: rootLang,
            isRightToLeft,
        })) ||
        [];
    if (!isLoadedProductDetails && !isInEditor) {
        return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
            React.createElement(SpecificationsSkeleton, null)));
    }
    if (!labels || !tabsData.length) {
        return null;
    }
    const onClickHandler = () => {
        if (productFactSheetUrlValue) {
            onOpenWindow(productFactSheetUrlValue, BLANK);
            setDigitalData(DigitalDataMutation.PDP_TECH_SPECS, null);
        }
    };
    const Title = SpecificationsTitle({
        label: labels.specifications_header_label,
    });
    const HeaderLink = SpecificationLink({
        label: labels.specifications_download_link,
        isVisible: productFactSheetUrlValue && !isMobileView,
        onClickHandler,
    });
    const BottomLink = SpecificationLink({
        label: labels.specifications_download_link,
        isVisible: productFactSheetUrlValue && isMobileView,
        onClickHandler,
    });
    const onTabChange = (newTab) => {
        setDigitalData(DigitalDataMutation.PDP_CLICK_SPECIFICATION, {
            specification: newTab.defaultTabTitle,
        });
    };
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(SectionHOC, { bgColor: colorCoreWhite1000, isRightToLeft: isRightToLeft, headerLeftSide: Title, headerRightSide: HeaderLink, bottomSection: BottomLink },
            React.createElement(Tabs, { tabData: tabsData, colorTheme: currentColorTheme, isRightToLeft: isRightToLeft, onTabChange: onTabChange }))));
}
Specifications.displayName = 'Specifications_AEMComponent';
